
<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0 mb-5 pb-5">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col mb-5">
        <h1 class="text-center py-4">Notificar a vendedores</h1>
        <FilterMenu
          :filterMenu="true"
          typePublication="product"
          :filterName="true"
          :filterAmountElements="true"
        />
        <div class="container">
          <table class="table">
            <thead class="thead-dark text-center">
              <tr>
                <th scope="col">Comprador</th>
                <th scope="col">Vendedor</th>
                <th scope="col">Codigo</th>
                <th class="d-none d-sm-table-cell" scope="col">Sacoin</th>
                <th class="d-none d-md-table-cell" scope="col">Fecha</th>
                <th class="d-none d-md-table-cell" scope="col">
                  ultima actualización
                </th>
                <th scope="col">Reclamo</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="text-center" v-if="purchaseFiltered.length">
              <tr v-for="purchase in purchaseFiltered" :key="purchase._id">
                <td>{{ purchase.buyer.username }}</td>
                <td>{{ purchase.seller.username }}</td>
                <td>{{ purchase.prettyID }}</td>
                <td class="d-none d-sm-table-cell">
                  SC${{
                    (purchase.sacoin + purchase.financiamiento).toFixed(2)
                  }}
                </td>
                <td class="d-none d-md-table-cell">
                  {{
                    purchase.creationDate.replace(/T/, " ").replace(/\..+/, "")
                  }}
                </td>
                <td class="d-none d-md-table-cell">
                  hace {{ getLastUpdate(purchase.creationDate) }} dias
                </td>
                <td>
                  <span v-if="purchase.claim" class="badge badge-danger p-2"
                    >Si</span
                  >
                </td>
                <td>
                  <span
                    class="material-icons text-info cursor-pointer"
                    title="enviar mail"
                    @click="handleOpenModal(purchase)"
                    >email</span
                  >
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="8" class="text-center">
                  No hay ninguna venta que cumpla con el filtro
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
      <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : modalMail.show }"
    :style="modalMail.show  ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>Enviar recordatorio</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="() => {modalMail.show = false;}">
          <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body text-left">
          <p class="border-bottom mt-1">Destinatario: {{modalMail.email}}</p>
          <p class="border-bottom">Asunto: Recuerda despachar la compra #{{modalMail.prettyID}}</p>
          <form class="border-bottom mt-3">
            <div class="" id="">Mensaje: Hola {{modalMail.seller}}. Por favor, recuerda despachar la venta #{{modalMail.prettyID}} de TreidBlue. <b class="text-primary cursor-pointer">Haz clic aquí</b> para despachar o ver información de la venta </div>
            <textarea v-model="modalMail.body" class="form-control border-0 p-0 pt-3" placeholder="Agregar mas detalle al correo..." id="" cols="30" rows="4"></textarea>  
          </form>     
        </div>
        <div class="p-3 text-right">
          <span v-show="!modalMail.success && !modalMail.onLoad" class="btn btn-treid" @click="handleCLickSendMail()">Enviar</span>
          <span v-show="modalMail.onLoad" class="btn btn-treid">Cargnado...</span>
          <p v-show="modalMail.success" class="alert alert-success text-center">Correo enviado con éxito</p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import FilterMenu from "@/components/admin/FilterMenu.vue";
import Configs from "@/configs/configs";
import Api from "../../tools/Api2";
import { mapState } from "vuex";
import api2 from '../../tools/Api2';

export default {
  name: "PurchasesNotification",
  data() {
    return {
      modalMail: {
        show: false,
        seller: '',
        prettyID: '',
        id: '',
        email: '',
        onLoad: false,
        success: false,
        sellerID: '',
        body: ''
      },
      purchases: [],
      url: Configs.API.BASE,
      filterMenuParms: {
        filterName: "",
        filterAmountElements: 50,
        filterState: {
          0: true,
          1: true,
          2: true,
        },
        orderBy: {
          sort: "creationDate",
          asc: false,
        },
      },
    };
  },
  computed: {
    ...mapState(["auth", "changes"]),
    purchaseFiltered() {
      return this.purchases
        .filter(
          (e) =>
            e.seller.username
              .toUpperCase()
              .includes(this.filterMenuParms.filterName.toUpperCase()) ||
            e.buyer.username
              .toUpperCase()
              .includes(this.filterMenuParms.filterName.toUpperCase()) ||
            e.prettyID.toString().includes(this.filterMenuParms.filterName)
        )
        .sort((a, b) => {
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return 1;
          }
          if (
            this.filterMenuParms.orderBy.asc
              ? a[this.filterMenuParms.orderBy.sort] <
                b[this.filterMenuParms.orderBy.sort]
              : a[this.filterMenuParms.orderBy.sort] >
                b[this.filterMenuParms.orderBy.sort]
          ) {
            return -1;
          }
          return 0;
        })
        .slice(0, this.filterMenuParms.filterAmountElements);
    },
  },
  methods: {
    handleCLickSendMail(){
      this.modalMail.onLoad = true;
      api2("buy/email-preparation").post({
        id: this.modalMail.id,
        body: this.modalMail.body
      }).finally(() => {
        this.modalMail.onLoad = false;
        this.modalMail.success = true;
      });
    },
    getLastUpdate(date) {
      const _date = new Date(date);
      _date;
      const now = new Date();
      return Math.ceil((now - _date) / (1000 * 3600 * 24));
    },
    handleOpenModal(sale) {
      this.modalMail = {
        show: true,
        success: false,
        seller: sale.seller.username,
        prettyID: sale.prettyID,
        id: sale._id,
        email: sale.seller.email,
        onLoad: false,
        sellerID: sale.seller._id,
        body: ''
      }
    }
  },
  components: {
    NavbarMain,
    NavbarAdmin,
    FilterMenu,
  },
  created: function () {
    Api("buy")
      .get("sales-in-preparation")
      .then((res) => {
        this.purchases = res.buys;
      });
  },
};
</script>
